import React, { useState, useRef, useEffect } from "react";
import Header from "../Section/Header";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Clock, Calendar } from "lucide-react";
import Footer from "../Section/Footer";
import sucess_gif from "../../Assests/sucess_gif.gif";
import {
  query_horoscope,
  server_post_data,
  view_subjecsts,
} from "../../ServiceConnection/serviceconnection";
import { useLocation } from "react-router-dom";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
import { X ,Search } from "lucide-react";
import { Modal } from "react-bootstrap";
import SearchListData from "../Section/SearchListData";
export default function AskQuestion() {
  const timeInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [ActiveUpdateBtn, setActiveUpdateBtn] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    dob: null,
    time: "",
    place: "",
    title: "",
    saveKundali: false,
  });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [topicList, setTopicList] = useState([]);
  //:-------------------------Modal Saved Kundali Data------------------------------
  
    const [topicList_kundli, setTopicList_kudli] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filteredTopicList, setFilteredTopicList] =
      useState(topicList_kundli);
      const [showModal , setshowModal] = useState(false);
  
    useEffect(() => {
      if (searchText === "") {
        setFilteredTopicList(topicList_kundli);
      } else {
        const filteredList = topicList_kundli
          .filter(
            (item) =>
              item.user_name &&
              item.user_name.toLowerCase().includes(searchText.toLowerCase())
          )
          .sort((a, b) => (a.user_name || "").localeCompare(b.user_name || ""));
        setFilteredTopicList(filteredList);
      }
    }, [searchText, topicList_kundli]);
  
    useEffect(() => {
      masterDataGet();
      masterDataGet_Kuldi_data();
    }, []);
    const masterDataGet_Kuldi_data = async () => {
      setIsLoading(true);
      const fd = new FormData();
      fd.append("flag", 7);
      fd.append("sub_id", 0);
      fd.append("cat_id", 0);
      fd.append("thread_id", 0);
  
      await server_post_data(view_subjecsts, fd)
        .then(async (Response) => {
          setIsLoading(false);
          let data = Response.split("~@~");
          if (parseInt(data[0]) === 1) {
            CustomAlert("Error", data[1]);
          } else {
            setTopicList_kudli(
              JSON.parse(JSON.parse(data[1])[0]["get_data_subs"])
            );
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    };
  const inputRef = useRef(null);

  const splitPlace = (placeString) => {
    if (!placeString) return { city: "", state: "", country: "" };

    const parts = placeString.split(",").map((part) => part.trim());

    return {
      city: parts[0] || "",
      state: parts[1] || "",
      country: parts[2] || "",
    };
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Please enter your full name.";
    if (!formData.gender) newErrors.gender = "Please select your gender.";
    if (!formData.dob) newErrors.dob = "Please select your birth date.";
    if (!formData.time) newErrors.time = "Please select your birth time.";
    if (!formData.place.trim())
      newErrors.place = "Please enter your birth place.";
    if (!formData.title.trim()) newErrors.title = "Please enter  title.";
    if (!message || message.trim().length < 50) {
      newErrors.message = "Please enter at least 50 characters.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const maxChars = 1000;
  const handleChange = (e) => {
    if (e.target.value.length <= maxChars) {
      setMessage(e.target.value);
    }
    setErrors({ ...errors, message: "" });
    setActiveUpdateBtn(true);
  };

  const isMaxReached = message.length === maxChars;

  const handleDynamic = async (type) => {
    setIsLoading(true);
    const { city, state, country } = splitPlace(formData.place);
    const dobDate = new Date(formData.dob);
    const dobYear = dobDate.getFullYear();
    const dobMonth = String(dobDate.getMonth() + 1).padStart(2, "0");
    const dobDay = String(dobDate.getDate()).padStart(2, "0");
    const fd = new FormData();
    fd.append("user_name", formData.name);
    fd.append("question_title", formData.title);
    fd.append("user_gender", formData.gender);
    fd.append("user_dob", `${dobYear}-${dobMonth}-${dobDay}`);
    fd.append("user_dobtime", formData.time);
    fd.append("query_box", message);
    fd.append("city_name", city);
    fd.append("state_name", state);
    fd.append("country_name", country);
    fd.append("latitude_data", formData.latitude);
    fd.append("longitude_data", formData.longitude);
    await server_post_data(query_horoscope, fd)
      .then((Response) => {
        setIsLoading(false);
        setShowSuccessModal(true);
        setActiveUpdateBtn(false);

        masterDataGet();
        setFormData({
          name: "",
          gender: "",
          dob: null,
          time: "",
          place: "",
          title: "",
        });
        setMessage("");
        setTimeout(() => {
          setShowSuccessModal(false);
        }, 2000);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      handleDynamic();
    }
  };

  useEffect(() => {
    masterDataGet();
  }, []);

  const masterDataGet = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("flag", 2);
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);

    await server_post_data(view_subjecsts, fd)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          setTopicList(JSON.parse(JSON.parse(data[1])[0]["get_data_subs"]));
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const openTimePicker = () => {
    if (timeInputRef.current) {
      timeInputRef.current.showPicker();
    }
  };

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["(cities)"],
        componentRestrictions: { country: "in" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      const formatted = place.formatted_address || place.name || "";

      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      setFormData((prev) => ({
        ...prev,
        place: formatted,
        latitude: lat ? lat.toFixed(6) : "",
        longitude: lng ? lng.toFixed(6) : "",
      }));

      setErrors((prev) => ({ ...prev, place: "" }));
    });

    return () => {
      window.google.maps.event.clearInstanceListeners(autocomplete);
    };
  }, []);
  const handleShowSaveSearchModl = () => {
    console.log("clickeck");
    setshowModal(true);
    masterDataGet_Kuldi_data();
  };
  const handleClose = () => {
    setshowModal(false);
  };
  const handleEditKundali = (kundali) => {
    // Parse the date string to create a Date object
    const parseDate = (dateString) => {
      if (!dateString) return null;

      // Handle different date formats
      let date;
      if (dateString.includes("-")) {
        // Format: YYYY-MM-DD
        date = new Date(dateString);
      } else if (dateString.includes("/")) {
        // Format: DD/MM/YYYY or MM/DD/YYYY
        const parts = dateString.split("/");
        if (parts.length === 3) {
          // Assuming DD/MM/YYYY format
          date = new Date(parts[2], parts[1] - 1, parts[0]);
        }
      }

      return date && !isNaN(date.getTime()) ? date : null;
    };

    // Format time to ensure it's in HH:MM format for HTML time input
    const formatTime = (timeString) => {
      if (!timeString) return "";

      console.log("Original time string:", timeString); // Debug log

      // Remove any extra spaces
      timeString = timeString.trim();

      // If time is already in HH:MM format
      if (timeString.match(/^\d{2}:\d{2}$/)) {
        console.log("Time already in HH:MM format:", timeString);
        return timeString;
      }

      // If time has seconds, remove them (HH:MM:SS -> HH:MM)
      if (timeString.match(/^\d{2}:\d{2}:\d{2}$/)) {
        const formatted = timeString.substring(0, 5);
        console.log("Removed seconds from time:", formatted);
        return formatted;
      }

      // Handle 12-hour format with AM/PM
      if (timeString.match(/\d{1,2}:\d{2}\s?(AM|PM|am|pm)/i)) {
        const match = timeString.match(/(\d{1,2}):(\d{2})\s?(AM|PM|am|pm)/i);
        if (match) {
          let hours = parseInt(match[1]);
          const minutes = match[2];
          const ampm = match[3].toUpperCase();

          // Convert to 24-hour format
          if (ampm === "AM" && hours === 12) {
            hours = 0;
          } else if (ampm === "PM" && hours !== 12) {
            hours += 12;
          }

          const formatted = `${hours.toString().padStart(2, "0")}:${minutes}`;
          console.log("Converted 12-hour to 24-hour:", formatted);
          return formatted;
        }
      }

      // Handle single digit hours (H:MM -> HH:MM)
      if (timeString.match(/^\d{1}:\d{2}$/)) {
        const formatted = "0" + timeString;
        console.log("Added leading zero to hour:", formatted);
        return formatted;
      }

      // Handle format like "9:30" -> "09:30"
      const timeMatch = timeString.match(/^(\d{1,2}):(\d{2})$/);
      if (timeMatch) {
        const hours = timeMatch[1].padStart(2, "0");
        const minutes = timeMatch[2];
        const formatted = `${hours}:${minutes}`;
        console.log("Formatted time:", formatted);
        return formatted;
      }

      console.log("Could not format time, returning original:", timeString);
      return timeString;
    };

    // Combine city, state, and country into place string
    const formatPlace = (city, state, country) => {
      const parts = [city, state, country].filter(
        (part) => part && part.trim()
      );
      return parts.join(", ");
    };

    // Update form data with kundali information
    setFormData({
      name: kundali.user_name || "",
      gender: kundali.user_gender ? kundali.user_gender.toLowerCase() : "",
      dob: parseDate(kundali.user_dob),
      time: formatTime(
        kundali.user_dobtime2 || kundali.user_dobtime || kundali.dobtime
      ),
      place: formatPlace(
        kundali.city_name,
        kundali.state_name,
        kundali.country_name
      ),
      title: kundali.question_title || "",
      latitude: kundali.latitude_data || "",
      longitude: kundali.longitude_data || "",
      saveKundali: false,
    });
    console.log(
      "Setting time to:",
      formatTime(
        kundali.user_dobtime2 || kundali.user_dobtime || kundali.dobtime
      )
    );
    console.log("Full kundali object:", kundali);

    setErrors({});
    setshowModal(false);
    setActiveUpdateBtn(true);
  };
  return (
    <>
      <Header />
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-[1050px] mx-auto py-4 lg:py-10 px-2 lg:px-5">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
              ❓ Ask a Question
            </h2>
            <p className="text-lg text-purple-300">
              Have a doubt or need help? Type your question below and we'll get
              back to you!
            </p>
          </div>

          <div
            className="rounded-lg text-card-foreground shadow-sm bg-slate-800/50 backdrop-blur-sm"
            style={{
              borderColor: "var(--primary-border)",
              borderWidth: "1.5px",
            }}
          >
            <div className="p-6 pt-[16px]">
              <form className="space-y-6">
                <div className="space-y-1">
                  <label
                    htmlFor="topic"
                    className="text-sm font-medium text-purple-200"
                  >
                    Select Topic <span className="text-red-400">*</span>
                  </label>
                  <div className="relative">
                    <select
                      id="topic"
                      className="appearance-none h-11 w-full rounded-md px-3 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                      style={{
                        borderColor: "var(--primary-border)",
                        borderWidth: "1.5px",
                      }}
                      value={formData.topic || ""}
                      onChange={(e) => {
                        setFormData({ ...formData, topic: e.target.value });
                        setErrors({ ...errors, topic: "" });
                        setActiveUpdateBtn(true);
                      }}
                    >
                      <option value="" disabled>
                        -- Select a Topic --
                      </option>
                      {topicList &&
                        topicList.length > 0 &&
                        topicList.map((item, index) => (
                          <option key={index} value={item.cat_data}>
                            {item.cat_data}
                          </option>
                        ))}
                    </select>
                    <svg
                      className="w-4 h-4 text-purple-300 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                  {errors.topic && (
                    <span className="text-sm text-red-400">{errors.topic}</span>
                  )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Full Name */}
                  <div className="space-y-1">
                    <label
                      htmlFor="name"
                      className="text-sm font-medium text-purple-200"
                    >
                      Full Name <span className="text-red-400">*</span>
                    </label>
                    <div className="flex items-center justify-between h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border">
                      <input
                        type="text"
                        id="name"
                        placeholder="Enter your full name"
                        className="custum_input"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData({ ...formData, name: e.target.value });
                          setErrors({ ...errors, name: "" });
                          setActiveUpdateBtn(true);
                        }}
                      />
                      <button
                        type="button"
                        aria-label="Search"
                        onClick={handleShowSaveSearchModl}
                      >
                        <Search
                          color="#c0a0e7"
                          className="mr-[-6px]"
                          size={20}
                        />
                      </button>
                    </div>

                    {errors.name && (
                      <span className="text-sm text-red-400">
                        {errors.name}
                      </span>
                    )}
                  </div>

                  {/* Gender */}
                  <div className="space-y-1 relative">
                    <label
                      htmlFor="gender"
                      className="text-sm font-medium text-purple-200"
                    >
                      Gender <span className="text-red-400">*</span>
                    </label>
                    <div className="relative">
                      <select
                        id="gender"
                        className="appearance-none h-11 w-full rounded-md px-3 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={formData.gender}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            gender: e.target.value,
                          });
                          setErrors({ ...errors, gender: "" });
                          setActiveUpdateBtn(true);
                        }}
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                      <svg
                        className="w-4 h-4 text-purple-300 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                    {errors.gender && (
                      <span className="text-sm text-red-400">
                        {errors.gender}
                      </span>
                    )}
                  </div>

                  {/* Date of Birth */}
                  <div className="space-y-1">
                    <label
                      htmlFor="dob"
                      className="text-sm font-medium text-purple-200"
                    >
                      Date of Birth <span className="text-red-400">*</span>
                    </label>
                    <div className="relative date_picker_kundalii">
                      <DatePicker
                        selected={formData.dob}
                        onChange={(date) => {
                          setFormData({ ...formData, dob: date });
                          setErrors({ ...errors, dob: "" });
                          setActiveUpdateBtn(true);
                        }}
                        dateFormat="dd/MM/yyyy"
                      
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        placeholderText="Select your birth date"
                        className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                          width: "100%",
                        }}
                      />
                      <Calendar
                        size={18}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                      />
                    </div>
                    {errors.dob && (
                      <span className="text-sm text-red-400">{errors.dob}</span>
                    )}
                  </div>

                  {/* Time of Birth */}
                  <div
                    className="space-y-1 timeofBirth"
                    onClick={openTimePicker}
                  >
                    <label
                      htmlFor="time"
                      className="text-sm font-medium text-purple-200"
                    >
                      Time of Birth <span className="text-red-400">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="time"
                        id="time"
                        ref={timeInputRef}
                        className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={formData.time}
                        onChange={(e) => {
                          setFormData({ ...formData, time: e.target.value });
                          setErrors({ ...errors, time: "" });
                          setActiveUpdateBtn(true);
                        }}
                      />
                      <Clock
                        size={18}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                      />
                    </div>
                    {errors.time && (
                      <span className="text-sm text-red-400">
                        {errors.time}
                      </span>
                    )}
                  </div>
                  {/* Place of Birth */}
                  <div className="space-y-1">
                    <label
                      htmlFor="place"
                      className="text-sm font-medium text-purple-200"
                    >
                      Place of Birth <span className="text-red-400">*</span>
                    </label>
                    <input
                      ref={inputRef}
                      type="text"
                      id="place"
                      placeholder="City, State, Country"
                      className="h-11 w-full rounded-md px-4 py-2 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                      style={{
                        borderColor: "var(--primary-border)",
                        borderWidth: "1.5px",
                      }}
                      value={formData.place}
                      onChange={(e) => {
                        setFormData({ ...formData, place: e.target.value });
                        setErrors({ ...errors, place: "" });
                        setActiveUpdateBtn(true);
                      }}
                    />
                    {errors.place && (
                      <span className="text-sm text-red-400">
                        {errors.place}
                      </span>
                    )}
                  </div>
                  {/* Full Name */}
                  <div className="space-y-1">
                    <label
                      htmlFor="title"
                      className="text-sm font-medium text-purple-200"
                    >
                      Title <span className="text-red-400">*</span>
                    </label>
                    <input
                      type="text"
                      id="title"
                      placeholder="Enter title"
                      className="h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                      style={{
                        borderColor: "var(--primary-border)",
                        borderWidth: "1.5px",
                      }}
                      value={formData.title}
                      onChange={(e) => {
                        setFormData({ ...formData, title: e.target.value });
                        setErrors({ ...errors, title: "" });
                        setActiveUpdateBtn(true);
                      }}
                    />
                    {errors.title && (
                      <span className="text-sm text-red-400">
                        {errors.title}
                      </span>
                    )}
                  </div>
                </div>

                {formData.latitude?.length > 0 &&
                  formData.longitude?.length > 0 && (
                    <div className="flex items-center gap-4">
                      <div className="text-[12px] font-medium text-purple-200">
                        Latitude: {formData.latitude}
                      </div>
                      <div className="text-[12px] font-medium text-purple-200">
                        Longitude: {formData.longitude}
                      </div>
                    </div>
                  )}
                {/* Message / Query */}
                <div className="space-y-1">
                  <div className="flex justify-between items-center w-full">
                    <label
                      htmlFor="message"
                      className="text-sm font-medium text-purple-200"
                    >
                      Your Message / Query{" "}
                      <span className="text-red-400">*</span>
                    </label>
                    <span
                      className={`text-sm font-medium ${
                        isMaxReached ? "text-red-400" : "text-purple-200"
                      }`}
                    >
                      Characters: {message.length} / {maxChars}
                    </span>
                  </div>

                  <textarea
                    id="message"
                    rows="4"
                    placeholder="Write your query or message (min 50 characters)"
                    className="w-full rounded-md h-[140px] px-4 py-2 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                    style={{
                      borderColor: "var(--primary-border)",
                      borderWidth: "1.5px",
                      resize: "none",
                    }}
                    value={message}
                    onChange={handleChange}
                    maxLength={maxChars}
                  />
                  {errors.message && (
                    <span className="text-sm text-red-400">
                      {errors.message}
                    </span>
                  )}
                </div>
                {/* Action Buttons */}
                <div className="pt-4 space-y-4">
                  <button
                    onClick={handleSubmit}
                    disabled={!ActiveUpdateBtn}
                    type="button"
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary hover:bg-primary/90 h-10 px-4 py-4 w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-[var(--white)] font-semibold rounded-full"
                  >
                    Post Query
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="custom-modal-success"
      >
        <Modal.Body className="text-center bg-slate-800 text-white p-0 rounded-lg ">
          <div className="flex flex-col items-center justify-center px-3 py-4 text-center relative">
            <X
              size={28}
              className="cursor-pointer absolute right-[0.2rem] md:right-[-2rem] top-[-2.2rem] md:top-[-2rem] rounded-full bg-white text-black p-[5px] shadow-md hover:scale-110 transition-transform duration-200"
              onClick={() => setShowSuccessModal(false)}
            />

            <div className="mb-4">
              <img
                src={sucess_gif}
                alt="Success"
                className="h-[180px] w-auto"
              />
            </div>
            <h5 className="text-[22px] font-bold text-green-400 mb-[12px]">
              Query Submitted Successfully!
            </h5>
            <p className="text-[14px] text-white/80 max-w-md mb-4">
              Thank you for reaching out. Your query has been successfully
              submitted. Our team will get back to you shortly with a response.
            </p>
          </div>
        </Modal.Body>
      </Modal>
      {/**----------------------Search Modal------------------- */}
      <SearchListData
        showModal={showModal}
        handleClose={handleClose}
        searchText={searchText}
        setSearchText={setSearchText}
        filteredTopicList={filteredTopicList}
        handleEditKundali={handleEditKundali}
      
      />
      <Footer />
    </>
  );
}
